import { graphql } from '__generated__';

import { useQueryStable } from '../useQueryStable';

export const GetJobInformation = graphql(/* GraphQL */ `
  query JobInformation(
    $start: Date!
    $end: Date!
    $uniqueId: String!
    $environmentId: BigInt!
  ) {
    performance(environmentId: $environmentId) {
      jobInformation(start: $start, end: $end, uniqueId: $uniqueId) {
        name
        jobId
      }
    }
  }
`);

type JobInformationParams = {
  startDate: string;
  endDate: string;
  uniqueId: string;
  environmentId: number;
  pause?: boolean;
};

export const useJobInformation = ({
  startDate,
  endDate,
  uniqueId,
  environmentId = 0,
  pause,
}: JobInformationParams) => {
  const query = useQueryStable({
    query: GetJobInformation,
    variables: {
      environmentId,
      start: startDate,
      end: endDate,
      uniqueId,
    },
    pause: pause || !environmentId || !startDate || !endDate || !uniqueId,
  });

  // TODO: we need a cache invalidation strategy for performance endpoints

  return query;
};
